<template>
  <div
    class="v-tag__wrapper"
    :class="{
      ['with-delete']: !!withDelete,
      ['prevent-ellipsis']: preventEllipsis
    }"
  >
    <span :title="label">
      {{ label }}
      <i
        v-if="withDelete"
        class="fal fa-times"
        v-on="
          removeHandler ? { click: e => removeHandler(e, _key, label) } : {}
        "
      ></i>
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VTag", {
  props: {
    removeHandler: VueTypes.func,
    _key: VueTypes.any,
    label: VueTypes.any,
    withDelete: VueTypes.bool.def(true),
    preventEllipsis: VueTypes.bool.def(false)
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-tag";

.#{$ns} {
  &__wrapper {
    @include textCropEllipsis();
    font-family: Lato-Regular, Arial, sans-serif;
    font-size: 12px;
    border-radius: 5px;
    color: $secondary-text-color;
    background-color: #ebedf0;
    padding: 6px 12px;
    margin: 0 5px 5px 0;
    position: relative;
    width: fit-content;
    height: fit-content;
    transition: padding 0.1s linear;
    max-width: 100px;

    &.prevent-ellipsis {
      max-width: 100%;
    }

    span {
      i {
        font-size: 13px;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        right: 5px;
        top: 6px;
        transition: opacity 0.1s linear;
        color: #b0b0b0;

        &:hover {
          color: $primary-color;
        }
      }
    }

    &:hover {
      i {
        opacity: 1;
        right: 7px;
      }
    }

    &.with-delete {
      &:hover {
        padding: 6px 22px 6px 8px;
      }
    }
  }
}
</style>
